/*
 * @Author: Haotian Zheng
 * @Date: 2023-07-13 19:17:14
 * @Descripttion:
 * @LastEditors: cuicuizi
 * @LastEditTime: 2024-05-16 11:43:54
 */
import axios from 'axios'
import { Loading, Message } from 'element-ui'
import router from '../router/index.js'
axios.defaults.withCredentials = true
axios.interceptors.request.use(
  (confing) => {
    if (confing.method == 'get') {
      confing.data = true
    }
    //获取localStorage中的token
    let token = localStorage.getItem('token')
    if (token) {
      confing.headers['tuToken'] = token
    }
    let tenantId = localStorage.getItem('tenantId')
    if (tenantId) {
      confing.headers['tenantId'] = tenantId
    }
    return confing
  },
  (error) => {
    return Promise.reject(error)
  }
)

//响应拦截

axios.interceptors.response.use(
  (response) => {
    if (response.data.code === 200) {
      return response
    } else {
      if (response && response.data && response.data.code === 401) {
        // 清空localStorage
        localStorage.removeItem('tenantId')
        localStorage.removeItem('companySimple')
        localStorage.removeItem('currentEmployeeSimpleInfo')
        localStorage.removeItem('token')
        // 跳转登录页
        router.push('/login')
      }

      if (response.data.code == 1100) {
        localStorage.setItem('disable', true)
        // 判断是否在''/companyDisable'页面
        if (router.currentRoute.path == '/companyDisable') {
          return response
        }
        router.push('/companyDisable')
      } else if (response.data.code == 1102) {
        // 员工被禁用
        router.push('/userDisable')
      }
      // } else if (response.data.code == 1103) {
      //   // 无企业 - 员工被删除
      //   router.push('/userDelete')
      // }
    }
    return response
  },
  (error) => {
    const data = error.response
    if (data && data.status === 200) {
      Message.error('请重新登录')
      //跳转到登录页面
      router.push('/login')
    } else if (data.message === '用户未登录') {
      router.push('/login')
    } else if (data.status === 500) {
      localStorage.removeItem('tenantId')
      localStorage.removeItem('companySimple')
      localStorage.removeItem('currentEmployeeSimpleInfo')
      localStorage.removeItem('token')
      router.push('/login')
    } else if (data.status === 401) {
      localStorage.removeItem('tenantId')
      localStorage.removeItem('companySimple')
      localStorage.removeItem('currentEmployeeSimpleInfo')
      localStorage.removeItem('token')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)
export default axios
